import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getPreCompOrganizationContactsData from '@usas/ui-web/state/orgUnitStaff/GetOrgUnitStaffData';
import postPreCompOrganizationContactsData from '@usas/ui-web/state/orgUnitStaff/PostOrgUnitStaffData';
import putPreCompOrganizationContactsData from '@usas/ui-web/state/orgUnitStaff/PutOrgUnitStaffData';
import deletePreCompOrganizationContactsData from '@usas/ui-web/state/orgUnitStaff/DeletePersonOrgRoleDurationData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const PreCompOrganizationContactsData = { INITIAL_STATE, getPreCompOrganizationContactsData, postPreCompOrganizationContactsData, putPreCompOrganizationContactsData, deletePreCompOrganizationContactsData };

export default PreCompOrganizationContactsData;